import Layout from '@eduzz/ui-layout';
import { BetaModule } from 'components/BetaModule';
import { serializeMenuItemLabel } from 'helpers/menu';
import * as React from 'react';
import { NavLink } from 'react-router-dom';

import { Permission } from './Permission';
import { SubMenuRoute } from './SubMenuRoute';

import type { Route } from './routes';

const { Sidebar } = Layout;
const { Item } = Sidebar;

type MenuRouteProps = {
  route: Route;
};

const MenuRoute = React.memo(({ route }: MenuRouteProps) => {
  const isSubmenu = route.nodes?.length > 0;

  if (isSubmenu) {
    return <SubMenuRoute route={route} />;
  }

  if (route.external) {
    return (
      <Permission route={route}>
        <BetaModule module={route.betaModule}>
          <Item
            id={`menu-item-${serializeMenuItemLabel(route.label)}`}
            as={NavLink}
            to={{ pathname: route.to }}
            target='_blank'
            rel='noopener noreferrer'
            icon={route.icon || undefined}
          >
            {route.label}
          </Item>
        </BetaModule>
      </Permission>
    );
  }

  return (
    <Permission route={route}>
      <BetaModule module={route.betaModule}>
        <Item id={`menu-item-${serializeMenuItemLabel(route.label)}`} as={NavLink} to={route.to} icon={route.icon || undefined}>
          {route.label}
        </Item>
      </BetaModule>
    </Permission>
  );
});

export { MenuRoute };
